import * as THREE from 'three';

export class Resizer {
  private camera: THREE.PerspectiveCamera;
  private renderer: THREE.WebGLRenderer;
  private callback?: () => void;
  private handleResizeBound: () => void;

  constructor(
    camera: THREE.PerspectiveCamera,
    renderer: THREE.WebGLRenderer
  ) {
    this.camera = camera;
    this.renderer = renderer;
    this.handleResizeBound = this.handleResize.bind(this);
    this.setupResizeListener();
  }

  private setupResizeListener(): void {
    window.addEventListener('resize', this.handleResizeBound);
  }

  private handleResize(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Update camera aspect ratio
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();

    // Update renderer size
    this.renderer.setSize(width, height);

    // Call optional callback
    if (this.callback) {
      this.callback();
    }
  }

  public onResize(callback: () => void): void {
    this.callback = callback;
  }

  public dispose(): void {
    window.removeEventListener('resize', this.handleResizeBound);
  }
}
